import CitySEOHead from "@/components/feature/CitySEOHead";
import SafetyHarborHeroSection from "./components/HeroSection";
import SafetyHarborStickyNav from "./components/StickyNav";
import SafetyHarborProcessingTimeSection from "./components/ProcessingTimeSection";
import SafetyHarborServicesSection from "./components/ServicesSection";
import SafetyHarborLocalAreaSection from "./components/LocalAreaSection";
import SafetyHarborTravelTimingSection from "./components/TravelTimingSection";
import SafetyHarborDestinationsSection from "./components/DestinationsSection";
import SafetyHarborTestimonialsSection from "./components/TestimonialsSection";
import SafetyHarborAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import SafetyHarborComparisonSection from "./components/ComparisonSection";
import SafetyHarborMistakesSection from "./components/MistakesSection";
import SafetyHarborHowItWorksSection from "./components/HowItWorksSection";
import SafetyHarborFAQSection, { faqs } from "./components/FAQSection";
import SafetyHarborHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import SafetyHarborFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function SafetyHarborPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Safety Harbor"
        state="Florida"
        stateAbbr="FL"
        route="/safety-harbor"
        title="Emergency Passport Safety Harbor, FL — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Safety Harbor, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Tampa Bay travelers, Pinellas County families, and Safety Harbor residents."
        geoPlacename="Safety Harbor, Florida"
        geoPosition="28.0044;-82.6948"
        faqs={faqs}
        servicesSchema={servicesList}
      />
      <SafetyHarborHeroSection />
      <SafetyHarborStickyNav />
      <SafetyHarborProcessingTimeSection />
      <SafetyHarborLocalAreaSection />
      <SafetyHarborServicesSection />
      <SafetyHarborTravelTimingSection />
      <SafetyHarborDestinationsSection />
      <SafetyHarborTestimonialsSection />
      <SafetyHarborAcceptanceFacilitiesSection />
      <SafetyHarborComparisonSection />
      <SafetyHarborMistakesSection />
      <SafetyHarborHowItWorksSection />
      <SafetyHarborFAQSection />
      <SafetyHarborHelpfulResourcesSection />
      <SafetyHarborFinalCTA />
    </div>
  );
}